












import {
	defineComponent,
} from '@vue/composition-api';
import CtaButton from './CtaButton.vue';

export default defineComponent({
	components: {
		CtaButton,
	},
	props: {
		ariaLabel: {
			type: String,
			required: true,
		},
		isSolid: Boolean,
	},
});
